import React, { createContext, useContext, useMemo } from 'react';

const Context = createContext();

export const useTemplateColumns = () => useContext(Context);

export const TemplateColumnsCalculatorProvider = ({
  children,
  columns,
  withCheckbox,
}) => {
  const templateColumns = useMemo(
    () => calcGridTemplateColumns(columns, withCheckbox),
    [columns, withCheckbox]
  );

  return (
    <Context.Provider value={templateColumns}>{children}</Context.Provider>
  );
};

function calcGridTemplateColumns(columns, withCheckbox) {
  let total = 0;
  const widths = [];

  for (const col of columns) {
    const width = parseInt(col.width, 10);
    widths.push(width);
    total += width;
  }

  const pxToFr = getPxToFrFn(total || 1);

  let output = withCheckbox ? 'max-content' : '';

  widths.forEach((width, index) => {
    output += `${output ? ' ' : ''}minmax(${columns[index].width}, ${pxToFr(
      width
    )})`;
  });

  return output;
}

function getPxToFrFn(total) {
  return (width) => `${Math.round((width / total) * 100) / 100}fr`;
}
